/* assets/ls-card-swapper.js — metal dots on collection cards (Emery)
 *
 * Tapping a metal dot now switches everything on the card to that metal:
 * images, material label, both card links (image + title), and the quick-add
 * "+" button. Previously only the images changed, so a shopper who picked
 * silver and tapped the card landed on the gold page, and "+" added gold.
 * Needs the data-url / data-variant-id / data-handle / data-available
 * attributes from snippets/metal-dots-card.liquid.
 */
(function () {
  function clearSrcset(img) {
    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
    var pic = img.closest('picture');
    if (pic) {
      pic.querySelectorAll('source').forEach(function (s) {
        s.removeAttribute('srcset');
        s.removeAttribute('data-srcset');
      });
    }
  }

  function setImage(img, url) {
    if (!img || !url || img.tagName !== 'IMG') return;
    clearSrcset(img);
    img.src = url;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.metal-dots--card .ls-swatch');
    if (!btn) return;
    e.preventDefault();

    var card = btn.closest('product-card, .product-card');
    if (!card || btn.classList.contains('is-active')) return;

    // Images (Prestige classes; card-swipe.js keeps these classes on the same <img> nodes)
    setImage(card.querySelector('.product-card__image--primary'), btn.dataset.image);
    setImage(card.querySelector('.product-card__image--secondary'), btn.dataset.hover || btn.dataset.image);

    // Links → selected metal's product page
    if (btn.dataset.url) {
      card.querySelectorAll('a.product-card__media, a.product-title').forEach(function (a) {
        a.href = btn.dataset.url;
      });
    }

    // Quick add → selected metal's variant
    if (btn.dataset.variantId) {
      card.querySelectorAll('product-form input[name="id"]').forEach(function (input) {
        input.value = btn.dataset.variantId;
      });
      var modal = card.querySelector('quick-buy-modal');
      if (modal && btn.dataset.handle) {
        modal.setAttribute('handle', btn.dataset.handle + '?variant=' + btn.dataset.variantId);
      }
    }
    var quickAdd = card.querySelector('.product-card__quick-add-button');
    if (quickAdd) quickAdd.hidden = btn.dataset.available === 'false';

    // Label + pressed state
    var labelEl = card.querySelector('[data-material-label]');
    if (labelEl && btn.dataset.label) labelEl.textContent = btn.dataset.label;

    card.querySelectorAll('.metal-dots--card .ls-swatch').forEach(function (el) {
      el.classList.remove('is-active');
      el.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('is-active');
    btn.setAttribute('aria-pressed', 'true');
  });
})();